import { Separator } from "@app/components/core/Separator/Separator"
import { addProduct, deleteOrderLine } from "@app/store/actions/orderActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { groupBy } from "@app/utils/objectUtils"
import { useSelector } from "@tecreation/js-state-react"
import OrderLine from "../OrderLine/OrderLine"
import OrderLines from "../OrderLines/OrderLines"

export const mergeLinesToCollections = formattedOrder => {
	formattedOrder.orderLines.forEach(orderLine => {
		orderLine.displayGuid = orderLine?.display?.guid
	})
	const groupedByCollection = groupBy(formattedOrder.orderLines, "displayGuid")

	const mergedLines = []

	for (let displayId in groupedByCollection) {
		if (displayId == "undefined") {
			mergedLines.push(...groupedByCollection[displayId])
		} else {
			const groupedLines = groupedByCollection[displayId]
			const line = {
				description: groupedLines[0].display.description,
				quantity: groupedLines[0].display.quantity,
				details: groupedLines.map(e => e.details.map(det => ({ ...e, ...det }))).flat(),
				collectionId: groupedLines[0].details[0].collectionId,
				typeId: ORDER_LINE_TYPES.Collection,
			}
			mergedLines.push(line)
		}
	}
	return mergedLines
}

const getProductLines = formattedOrder => {
	const lines = []

	const mergedLines = mergeLinesToCollections(formattedOrder)

	mergedLines.forEach(orderLine => {
		let details = orderLine.details.filter(detail => detail.typeId === ORDER_LINE_TYPES.Article || detail.typeId === ORDER_LINE_TYPES.Voucher)
		if (details.length > 0) {
			lines.push({
				...orderLine,
				details,
			})
		}
	})

	return lines
}

export default function Products({ formattedOrder, isEditable, onAction }) {
	const productLines = getProductLines(formattedOrder)
	const products = useSelector(state => state.order.products)

	const { data: stringData } = useGetStrings()
	const { orderOverviewProductsTitle } = stringData || {}

	if (productLines.length) {
		return (
			<div className="mt-4">
				<h2 id="order-overview-products-title" className="f4 regular">
					{orderOverviewProductsTitle}
				</h2>
				<Separator />
				<OrderLines ariaLabelledBy="order-overview-products-title">
					{productLines.map((product, index) => {
						const productId = product.details[0].articleId
						const foundProduct = products[productId]
						return (
							<OrderLine
								key={index}
								isEditable={isEditable}
								showMinus
								orderLine={product}
								onMinus={() => {
									deleteOrderLine(foundProduct ? foundProduct.article : product)
									onAction()
								}}
								onPlus={() => {
									addProduct(foundProduct ? foundProduct.article : product)
									onAction()
								}}
							/>
						)
					})}
				</OrderLines>
			</div>
		)
	}
}
